module.exports = __webpack_public_path__ + "static/media/HighCard.029a6ca4.jpeg";